<template>
  <v-card elevation="0" class="all-trade-tab rounded-0" :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
    <v-tabs :background-color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
      <v-tab class="pl-0 ml-0">
        <v-icon class="blink" color="#FF567F"> mdi-circle-small </v-icon>
        Live Trades
      </v-tab>
      <v-tab> History </v-tab>
      <v-tab> Summary </v-tab>
      <v-tab> Transaction </v-tab>

      <v-tab-item>
        <LiveTab></LiveTab>
      </v-tab-item>
      <v-tab-item>
        <HistoryTab></HistoryTab>
      </v-tab-item>
      <v-tab-item>
        <ChartTab></ChartTab>
      </v-tab-item>
      <v-tab-item>
        <TransactionTab></TransactionTab>
      </v-tab-item>

    </v-tabs>
  </v-card>
</template>
<script>
import ChartTab from './ChartTab';
import HistoryTab from './HistoryTab';
import LiveTab from './LiveTab';
import TransactionTab from './TransactionTab';

export default {
  components: {
    TransactionTab,
    LiveTab,
    HistoryTab,
    ChartTab,
  },
};
</script>
